
// https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb

export default class ColorUtil {

    static hexToRGB(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    static calcBrightness(r,g,b)
    {
        // from http://alienryderflex.com/hsp.html
        return Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
        );
    }

    static brightness(color) {
        if ( typeof(color) === "string" )
        {
            var breakout = this.hexToRGB(color);
            if(breakout)
            {
                return this.calcBrightness(breakout.r, breakout.g, breakout.b);
            }
        }
        else if ( typeof(color) === "object" )
        {
            if(color.isArray())
            {
                if(color.length >= 3)
                    return this.calcBrightness(color[0]. color[1], color[2]);
                return null;
            }
            else
            {
                return this.calcBrightness(color.r, color.g, color.b);
            }
        }
        return null;
    }

    static isDark(color)
    {
        var brightness = this.brightness(color);

        if(brightness && brightness < 127.5)
        {
            return true;
        }
        return false;
    }

    static isReallyDark(color)
    {
        var brightness = this.brightness(color);

        if(brightness && brightness < 60)
        {
            return true;
        }
        return false;
    }

}

